import { useState } from "react";
import { Link } from "react-router-dom";

import { t } from "../../lib/i18n";
import {
  dismissSetupBanner,
  isSetupBannerDismissed,
} from "../../routes/setup/SetupWizard";

interface SetupBannerProps {
  /** Hide the banner if the system has already been bootstrapped. */
  empty: boolean;
}

/**
 * Top-of-Dashboard call-to-action when this on-prem instance has no devices
 * enrolled yet. Dismissable per-browser via localStorage; the wizard itself
 * also dismisses on finish / "Don't show again".
 */
export function SetupBanner({ empty }: SetupBannerProps) {
  const [dismissed, setDismissed] = useState(() => isSetupBannerDismissed());

  if (!empty || dismissed) return null;

  return (
    <div
      role="region"
      aria-label={t("setup.banner.ariaLabel")}
      className="setup-banner"
    >
      <div className="setup-banner__body">
        <div className="setup-banner__title">{t("setup.banner.title")}</div>
        <div className="setup-banner__subtitle">{t("setup.banner.subtitle")}</div>
      </div>
      <div className="setup-banner__actions">
        <Link to="/setup/settings" className="btn btn--sm">
          {t("setup.banner.start")}
        </Link>
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          onClick={() => {
            dismissSetupBanner();
            setDismissed(true);
          }}
        >
          {t("setup.banner.dismiss")}
        </button>
      </div>
    </div>
  );
}
